import { useEffect, useState } from "react";
import { Sparkles, X, Expand } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { AIChat, AI_ELIGIBLE } from "@/components/AIChat";
import { useAuth } from "@/context/AuthContext";

export function openAIWidget() {
  window.dispatchEvent(new CustomEvent("uv-open-ai"));
}

export function AIChatWidget() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [sessionId, setSessionId] = useState(() => localStorage.getItem("ai_widget_session") || null);

  useEffect(() => {
    const h = () => setOpen(true);
    window.addEventListener("uv-open-ai", h);
    return () => window.removeEventListener("uv-open-ai", h);
  }, []);

  if (!AI_ELIGIBLE(user) || user?.impersonated) return null;

  const onSession = (sid) => {
    setSessionId(sid);
    if (sid) localStorage.setItem("ai_widget_session", sid);
    else localStorage.removeItem("ai_widget_session");
  };

  if (!open) return null;
  return (
    <div className="no-print fixed right-4 bottom-4 z-50 w-[min(400px,calc(100vw-2rem))] h-[min(600px,calc(100vh-6rem))] rounded-xl border border-slate-200 bg-slate-50 shadow-2xl flex flex-col overflow-hidden" data-testid="ai-widget-panel">
      <div className="flex items-center justify-between px-3.5 py-2.5 bg-slate-900 text-white">
        <span className="flex items-center gap-2 text-sm font-medium"><Sparkles className="h-4 w-4 text-amber-300" /> Ask SalesCore</span>
        <span className="flex items-center gap-1">
          <button onClick={() => onSession(null)} className="text-[11px] text-slate-300 hover:text-white px-2 py-1 rounded hover:bg-white/10" data-testid="ai-widget-new">New</button>
          <button onClick={() => { setOpen(false); navigate("/ask-ai"); }} className="p-1.5 rounded hover:bg-white/10" title="Open full page" data-testid="ai-widget-expand"><Expand className="h-4 w-4" /></button>
          <button onClick={() => setOpen(false)} className="p-1.5 rounded hover:bg-white/10" data-testid="ai-widget-close"><X className="h-4 w-4" /></button>
        </span>
      </div>
      <AIChat sessionId={sessionId} onSession={onSession} compact />
    </div>
  );
}
